
































































import Vue from 'vue';
import { setTimeout } from 'timers';

import SiteFooter from '@/components/SiteFooter.vue';

export default Vue.extend({
  components: {
    SiteFooter,
  },
  data() {
    return {
      scrolling: false,
      navVisible: false,
      mouseStateClose: false,
    };
  },
  methods: {
    handleScroll() {
      this.scrolling = window.scrollY > 50 ? true : false;
    },
    openNav() {
      document.querySelector('html')!.classList.add('overflow-hidden');
      document.querySelector('body')!.classList.add('nav-visible');
      this.navVisible = true;
    },
    closeNav() {
      document.querySelector('html')!.classList.remove('overflow-hidden');
      document.querySelector('body')!.classList.remove('nav-visible');
      this.menuLabel = this.$i18n.locale === 'it' ? 'contatti' : 'contacts';
      this.navVisible = false;
    },
    toggleNav() {
      if ( this.navVisible ) {
        this.closeNav();
      } else {
        this.openNav();
      }
    },
    mouseOutNav() {
      document.getElementById('custom-cursor')!.classList.add('close');
      this.mouseStateClose = true;
    },
    mouseInNav() {
      document.getElementById('custom-cursor')!.classList.remove('close');
      this.mouseStateClose = false;
    },
    changeLocale() {
      const html = document.documentElement;
      if (this.$i18n.locale === 'it') {
        this.$router.push('/en');
        html.setAttribute('lang', 'en');
      } else {
        this.$router.push('/');
        html.setAttribute('lang', 'it');
      }
    },
    handleClick() {
      if ( this.mouseStateClose ) {
        this.closeNav();
        this.mouseInNav();
      }
    },
    goContatti() {
      const contatti = document.getElementById('main-footer');
      const contattiOffsetTop = contatti!.offsetTop;
      const sections = document.querySelectorAll('.section');
      sections.forEach((el) => {
        el.classList.add('in-view');
      });
      document.documentElement.scrollTop = contattiOffsetTop;
      this.closeNav();
      this.mouseOutNav();
    },
  },
  computed: {
    switchLangLabel() {
      if (this.$i18n.locale === 'en') {
        return 'Italiano';
      } else {
        return 'English';
      }
    },
    menuLabel() {
      if (this.$i18n.locale === 'en') {
        return 'contacts';
      } else {
        return 'contatti';
      }
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('click', this.handleClick);
    const html = document.documentElement;
    if ( this.$i18n.locale === 'en' ) {
      html.setAttribute('lang', 'en');
    } else {
      html.setAttribute('lang', 'it');
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('click', this.handleClick);
  },
});
